import vsmVuexModule from "./vsm-store";
import vsmPlugin from "./vsm-plugin";

export default {
  store: vsmVuexModule,
  plugin: vsmPlugin,
};
